import { useState, useEffect, useRef } from 'react';

export default function useIdleDetection(timeoutMs = 180000) {
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const reset = () => {
      setIsIdle(false);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setIsIdle(true), timeoutMs);
    };

    // Bubbling events (mouse/keyboard/touch) — listen normally
    const bubblingEvents = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'pointermove'];
    bubblingEvents.forEach(e => document.addEventListener(e, reset, { passive: true }));
    // Scroll does NOT bubble from inner overflow containers — capture phase catches all of them
    document.addEventListener('scroll', reset, { passive: true, capture: true });

    const handleVisibility = () => {
      if (document.hidden) {
        clearTimeout(timerRef.current);
      } else {
        reset();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    // Start the timer
    timerRef.current = setTimeout(() => setIsIdle(true), timeoutMs);

    return () => {
      clearTimeout(timerRef.current);
      bubblingEvents.forEach(e => document.removeEventListener(e, reset));
      document.removeEventListener('scroll', reset, { capture: true });
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [timeoutMs]);

  return isIdle;
}
